import React from 'react';
import PropTypes from 'prop-types';

import UserRole from '@careerstart/wae-common/src/main/constants/user-role';
import LanguageConverter from '@careerstart/wae-common/src/main/helperFunction/LanguageConverter';
import { Box, Tooltip } from '@mui/material';

import WaeButton, { BUTTON_VARIANT } from '../../../components/Button';
import theme from '../../../theme';
import { PRIMARY_COLOR } from '../../../theme/colorConstants';
import { BULK_ACTION_TYPES } from '../timekeepingConstants';
import { getActionButtonDisableMessage } from '../timekeepingHelpers';

const TimekeepingBulkButtons = ({
  userRole,
  selectedPlacementIds,
  allTimecards,
  openApproveModal,
  openFinalizeModal,
  openResolveModal,
}) => {
  const selectedTimecardObjects = allTimecards.flatMap((candidate) =>
    candidate.timecards.filter((timecard) => selectedPlacementIds.includes(timecard.placementId))
  );

  const resolveDisableKey = getActionButtonDisableMessage(
    selectedTimecardObjects,
    BULK_ACTION_TYPES.RESOLVE
  );

  const finalizeDisableKey = getActionButtonDisableMessage(
    selectedTimecardObjects,
    BULK_ACTION_TYPES.FINALIZE
  );

  const approveDisableKey = getActionButtonDisableMessage(
    selectedTimecardObjects,
    BULK_ACTION_TYPES.APPROVE
  );

  return (
    <Box sx={{ justifyContent: 'space-between' }}>
      {userRole === UserRole.ADMIN && (
        <>
          <Tooltip title={resolveDisableKey && LanguageConverter(resolveDisableKey)}>
            <span>
              <WaeButton
                variant={BUTTON_VARIANT.DEFAULT}
                actionColor={PRIMARY_COLOR[70]}
                onClick={openResolveModal}
                sx={{ mr: theme.spacing(1) }}
                disabled={!!resolveDisableKey}
              >
                {LanguageConverter('buttonText.resolve')}
              </WaeButton>
            </span>
          </Tooltip>

          <Tooltip title={finalizeDisableKey && LanguageConverter(finalizeDisableKey)}>
            <span>
              <WaeButton
                variant={BUTTON_VARIANT.DEFAULT}
                actionColor={PRIMARY_COLOR[70]}
                onClick={openFinalizeModal}
                disabled={!!finalizeDisableKey}
              >
                {LanguageConverter('buttonText.finalize')}
              </WaeButton>
            </span>
          </Tooltip>
        </>
      )}
      {userRole === UserRole.EMPLOYER && (
        <Tooltip title={approveDisableKey && LanguageConverter(approveDisableKey)}>
          <span>
            <WaeButton
              variant={BUTTON_VARIANT.DEFAULT}
              actionColor={PRIMARY_COLOR[70]}
              onClick={openApproveModal}
              disabled={approveDisableKey}
            >
              {LanguageConverter('buttonText.approve')}
            </WaeButton>
          </span>
        </Tooltip>
      )}
    </Box>
  );
};
export default TimekeepingBulkButtons;

TimekeepingBulkButtons.propTypes = {
  userRole: PropTypes.string,
  selectedPlacementIds: PropTypes.arrayOf(PropTypes.string),
  allTimecards: PropTypes.arrayOf(PropTypes.shape({})),
  openApproveModal: PropTypes.func,
  openFinalizeModal: PropTypes.func,
  openResolveModal: PropTypes.func,
};
